import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
import { callAPI ,Method } from "../../commonFunctions/CommonFunctions";

export const PurchaseReport: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);

  // later you can modify these column names
  const purchaseColumns: GridColDef[] = [
    { field: "customerName", headerName: "Customer Name", flex: 1 },
    { field: "invoiceCount", headerName: "Invoice Count", flex: 1 },
    { field: "sale", headerName: "Sale", flex: 1 },
    { field: "taxSale", headerName: "Tax Sale", flex: 1 },
  ];

  const handleApply = async (payload: any) => {
    try {
      // later you will tell exact API endpoint
      const response = await callAPI("reports/salesReport", Method.POST, payload);
      setRows(response?.data || []);
    } catch (err) {
      console.log("Error fetching Sales Report", err);
    }
  };

  return (
    <ReportBaseTemplate
      title="Purchase Report"
      columns={purchaseColumns}
      rows={rows}
      onApply={handleApply}
    />
  );
};

export default PurchaseReport;
